import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMorning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 256,
	height: 72,
	viewBox: "0 0 256 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_16794_322301)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M256 0H0V72H256V0Z",
				fill: "url(#paint0_linear_16794_322301)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M274.254 46.8478C278.539 28.8891 267.454 10.857 249.495 6.57197C231.537 2.28697 213.505 13.3717 209.22 31.3305C204.935 49.2892 216.019 67.3213 233.978 71.6063C251.937 75.8913 269.969 64.8066 274.254 46.8478Z",
				fill: "#FFC612"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M256 67.5H0V72H256V67.5Z",
				fill: "url(#paint1_linear_16794_322301)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M267.356 67.0795C269.006 67.0795 270.356 66.1494 270.356 65.0094C270.356 63.8694 269.006 62.9395 267.356 62.9395H216.836C215.186 62.9395 213.836 63.8694 213.836 65.0094C213.836 66.1494 214.566 67.0795 215.456 67.0795C216.346 67.0795 217.076 68.0094 217.076 69.1494C217.076 70.2894 218.426 71.2195 220.076 71.2195H230.636C232.286 71.2195 233.636 72.0095 233.636 72.9745C233.636 73.9395 232.286 74.7294 230.636 74.7294H223.766C222.116 74.7294 220.766 75.6595 220.766 76.7995C220.766 77.9395 222.116 78.8694 223.766 78.8694H225.146C226.796 78.8694 228.146 79.7595 228.146 80.8495C228.146 81.9395 229.156 82.8295 230.396 82.8295C231.636 82.8295 232.646 83.7245 232.646 84.8195C232.646 85.9145 233.496 86.8094 234.536 86.8094C235.576 86.8094 236.426 87.6545 236.426 88.6895C236.426 89.7245 237.776 90.5695 239.426 90.5695H245.846C247.496 90.5695 248.846 89.6395 248.846 88.4995C248.846 87.3595 247.496 86.4294 245.846 86.4294H245.006C243.356 86.4294 242.006 85.6195 242.006 84.6295C242.006 83.6395 243.356 82.8295 245.006 82.8295H254.126C255.776 82.8295 257.126 81.8994 257.126 80.7594C257.126 79.6194 255.776 78.6895 254.126 78.6895H247.526C245.876 78.6895 244.526 77.8595 244.526 76.8445C244.526 75.8295 245.876 74.9995 247.526 74.9995H262.856C264.506 74.9995 265.856 74.0694 265.856 72.9294C265.856 71.7894 264.506 70.8595 262.856 70.8595H252.296C250.646 70.8595 249.296 70.0095 249.296 68.9695C249.296 67.9295 250.646 67.0795 252.296 67.0795H267.356Z",
				fill: "#FFB717"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M209.397 65.1444C209.397 66.3344 208.047 67.3044 206.397 67.3044H205.797C204.147 67.3044 202.797 66.3344 202.797 65.1444C202.797 63.9544 204.147 62.9844 205.797 62.9844H206.397C208.047 62.9844 209.397 63.9544 209.397 65.1444Z",
				fill: "#FFB717"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_16794_322301",
			x1: 128,
			y1: 72,
			x2: 128,
			y2: 0,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#FF7712" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .09,
					stopColor: "#F3781A"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .25,
					stopColor: "#D37A31"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .46,
					stopColor: "#A07F56"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .72,
					stopColor: "#59868A"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#038EC9"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_16794_322301",
			x1: 128,
			y1: 72.0005,
			x2: 128,
			y2: 67.5,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#D3630F" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#D36E2A"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_16794_322301",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 256,
				height: 72,
				fill: "white"
			})
		})
	] })]
});
export default SvgMorning;
